/**
 * 権限セット権限詳細保時用VO
 */
export class AuthoritySetInformationDetailModel {
  /** 権限セットID */
  public authoritySetId: string = <string>'';
  /** 権限セット名 */
  public authoritySetName: string = <string>'';
  /** 管理者区分(0:非管理者、1:管理者) */
  public adminDiv: string = <string>'';
  /** 権限セット説明 */
  public authoritySetExplanation: string = <string>'';
  /** 権限ステータス(0:有効、1:無効) */
  public authorityStatus: string = <string>'';
  /** 画面機能権限一覧 */
  public funcAuthorityList: Array<any> = null;

}